import { render } from "./ConfirmModal.vue?vue&type=template&id=02d4fe5c"
import script from "./ConfirmModal.vue?vue&type=script&lang=js"
export * from "./ConfirmModal.vue?vue&type=script&lang=js"
script.render = render

export default script